/* eslint-disable @typescript-eslint/no-explicit-any */
export const generateOptions = <T>({
  list,
  labelKey,
  valueKey,
}: {
  list: T[];
  labelKey?: keyof T;
  valueKey?: keyof T;
  withAllOptions?: boolean;
}) => {
  let optionsList = [];
  if (labelKey && valueKey) {
    optionsList = list?.map((item) => ({
      label: item[labelKey] as string,
      value: item[valueKey] as any,
    }));
  } else {
    optionsList = list?.map((item) => ({
      label: item as string,
      value: item as any,
    }));
  }

  return optionsList;
};
